import { combineReducers } from 'redux'
import layout from './layout'

export default combineReducers({
  layout,
})
